import './App.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import './i18n';
import App from './components/App';
import store from './store';

const render = () => ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'));

render();

store.subscribe(render);



// WEBPACK FOOTER //
// ./src/index.js